import { Html } from '@react-three/drei'
import type { HtmlProps } from '@react-three/drei/web/Html'

export function FullscreenHtml({ children, ...props }: HtmlProps) {
  return (
    <Html
      portal={{ current: document.body }}
      className="pointer-events-none fixed inset-0 h-dvh w-dvw"
      calculatePosition={() => [0, 0]}
      {...props}
    >
      {children}
    </Html>
  )
}
